var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"alert",class:{
    'stickeralert mx-0 mt-0 px-0': _vm.position == 'top',
    'cookiealert mb-0 text-center': _vm.position == 'bottom',
  },attrs:{"role":"alert"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }